import Icon from "@mdi/react";
import { DeviceStatus } from "../../../../deviceList/_common/DeviceStatus";
import { LoadingIcon } from "../../../../../decorators/loading/Loading";
import { mdiUpdate } from "@mdi/js";
import { useId } from "react";
import { Value } from "../_shared/Value";
import { useDelayedOfflineStatus } from "../../../../../hooks/useDelayedOfflineStatus";

export function DeviceStatusInfo() {
  const componentId = useId();

  const state = useDelayedOfflineStatus(componentId);

  return (
    <Value
      label="Service status"
      value={
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <DeviceStatus status={state.status} />
            {state.isLoading && <LoadingIcon />}
            {state.dateTime && (
              <div className="flex items-center gap-1 font-mono text-xs font-extralight italic text-brand-500">
                <Icon path={mdiUpdate} className="h-3 w-3" />
                {state.dateTime}
              </div>
            )}
          </div>
        </div>
      }
    />
  );
}
